import { ProductType } from "../../Firebase/ServerOwnership";
export const Collection_redeemKeys = "redeemKeys";
export const Collection_ProductOwnerShip = "productOwnerships";
export const Collection_keyProductOwnerShip = "keyProductOwnerships";
export const Collection_customizedProductOwnerShip =
  "customizedProductOwnerships";

const dict = {
  downloadable: Collection_ProductOwnerShip,
  key: Collection_keyProductOwnerShip,
  customized: Collection_customizedProductOwnerShip,
  physical: Collection_ProductOwnerShip,
};
export function getCollectionPathFromProductType(type: ProductType) {
  return dict[type];
}

export const Collection_ExternalKeyCursor = "externalKeyCursor"; //現在key被分到哪了
export const Collection_ExternalKeyData = "externalKeys"; //外部key資料
